export default __webpack_public_path__ + "static/scientist7-75416db22c8169e161b1970af5e9b406.png";